import http from './http';
import LocalStorage from "../services/localStorage";

function formatUser(user) {
  return user;
}

export default {
  all() {
    return http().get(`/v1/users`).then((response) => {
      response.data = response.data.map(formatUser);

      return response;
    });
  },
  get(id) {
    return http().get(`/v1/users/${id}`).then(formatUser);
  },
  create(data, validationErrors = {}) {
    return http(validationErrors).post(`/v1/users`, data).then(formatUser);
  },
  update(data, validationErrors = {}) {
    return http(validationErrors).put(`/v1/users/${data.id}`, data).then((response) => {
      // checks for owners updating other user account
      if (LocalStorage.getAuthUser().id === response.data.id) {
        LocalStorage.setAuthUser(response.data)
      }

      formatUser()
    });
  },
  deleteAvatarImage(id) {
    return http().delete(`/v1/users/${id}/avatar_image`).then(formatUser);
  },
  restore(user_id) {
    return http().put(`/v1/users/${user_id}/restore`).then(formatUser);
  },
  uploadAvatarImage(id, file) {
    let formData = new FormData();
    formData.append('avatar_image', file);
    return http().post(`/v1/users/${id}/avatar_image`, formData).then(formatUser);
  },

  uploadEmailSignature(id, file, fileName, validationErrors = {}) {
    let formData = new FormData();
    formData.append('file', file);
    formData.append('file_name', fileName);
    return http(validationErrors).post(`/v1/users/${id}/upload_email_signature_image`, formData).then(formatUser);
  },

  updateEmailSignature(data, validationErrors = {}) {
    return http(validationErrors).put(`/v1/users/${data.id}/email_signature`, data).then(formatUser);
  },

  /**
   * This is used to change the users notification phone number.
   *
   * Api Request: UpdateUserNotificationPhoneNumberRequest
   *
   * @param data
   * @returns {Promise<AxiosResponse<any>>}
   */
  updateNotificationPhoneNumber(data, validationErrors = {}) {
    return http(validationErrors).put(`/v1/users/${data.id}/notifications_phone_number`, data).then(formatUser);
  },
  /**
   * This is used to test the notification number
   *
   * @param data
   * @returns {Promise<AxiosResponse<any>>}
   */
  testNotificationNumber(data, validationErrors = {}) {
    return http(validationErrors).post(`/v1/users/${data.id}/test_notification_number`).then(formatUser);
  },
  updatePassword(data, validationErrors = {}) {
    return http(validationErrors).put(`/v1/users/${data.id}/password`, data).then(formatUser);
  },
  /**
   * This is to update the owner
   *
   * @param data
   * @returns {Promise<AxiosResponse<any>>}
   */
  updateOwner(data, validationErrors = {}) {
    return http(validationErrors).put(`/v1/users/${data.id}/owner`, data).then(formatUser);
  },
  /**
   * This route needs to be called in order to update the users email
   *
   * @param data // UpdateUserEmailRequest
   * @returns {Promise<AxiosResponse<any>>}
   */
  updateEmail(data, validationErrors = {}) {
    return http(validationErrors).put(`/v1/users/${data.id}/email_address`, data).then(formatUser);
  },
  /**
   * When you delete a user, there is an option to assign records that that user is working on to a replacement user
   *
   * Api Request: DeleteUserRequest
   *
   * @param id
   * @param replacementUser
   * @returns {Promise<AxiosResponse<any>>}
   */
  delete(id, replacementUser) {
    return http().post(`/v1/users/${id}/delete_user`, replacementUser);
  },
  getNotificationSettings(user_id) {
    return http().get(`/v1/users/${user_id}/notification_settings`);
  },
  updateNotificationSettings(data, validationErrors = {}) {
    return http(validationErrors).put(`/v1/users/${data.id}/notification_settings`, data.settings);
  },
  updateEndOfDayReport(data, validationErrors = {}) {
    return http(validationErrors).put(`/v1/users/${data.id}/send_end_of_day_report_at`, data);
  },
  updateAppointmentDefaults(id, data, validationErrors = {}) {
    return http(validationErrors).put(`/v1/users/${id}/appointment_defaults`, data);
  },

  toggleOneClick(data, validationErrors = {}) {
    return http(validationErrors).put(`/v1/users/${data.id}/one_click`, data);
  },
  updateOutboundCallSettings(data, validationErrors = {}) {
    return http(validationErrors).put(`/v1/users/${data.id}/outbound_call_settings`, data);
  },
  getUnreadNotifications(userId) {
    return http().get(`/v1/users/${userId}/notifications/unread`);
  },
  updatePermissions(userId, data) {
    return http().put(`/v1/users/${userId}/permissions`, data);
  },

  getFilterData(id) {
    return http().get(`/v1/users/${id}/filter_data`);
  },
  updateFilterData(userId, data) {
    return http().put(`/v1/users/${userId}/filter_data`, {filters: data});
  },
  updateDefaultTablePresets(id, data) {
    return http().put(`/v1/users/${id}/default_table_presets`, data);
  },
  updateLeadTimelineSettings(id, data) {
    return http().put(`/v1/users/${id}/lead_timeline_settings`, data);
  },
}
